<script setup>
import LucideIcon from '@/components/ui/LucideIcon.vue';
import vReveal from '@/directives/reveal';

const CATEGORIES = [
  { name: 'Wildlife & Safari', icon: 'paw-print', count: '24 Tours' },
  { name: 'Adventure', icon: 'mountain', count: '18 Tours' },
  { name: 'Cultural & Heritage', icon: 'landmark', count: '12 Tours' },
  { name: 'Eco-Tourism', icon: 'leaf', count: '9 Tours' },
  { name: 'Beach & Coastal', icon: 'palmtree', count: '15 Tours' },
  { name: 'Marine', icon: 'fish', count: '8 Tours' },
  { name: 'Luxury', icon: 'gem', count: '11 Tours' },
  { name: 'Food & Culinary', icon: 'utensils-crossed', count: '7 Tours' },
  { name: 'Religious', icon: 'church', count: '5 Tours' },
  { name: 'Business & MICE', icon: 'briefcase', count: '6 Tours' },
];
</script>

<template>
  <section class="categories" id="categories">
    <div class="wrap">
      <div class="section-head" v-reveal>
        <span class="eyebrow">Ways To Explore</span>
        <h2>Ten ways to fall for Tanzania</h2>
        <p>From dawn game drives to spice-island feasts — choose the journey that moves you.</p>
      </div>
      <div class="cat-grid">
        <a
          v-for="(c, i) in CATEGORIES"
          :key="c.name"
          href="#tour-packages"
          class="cat"
          v-reveal
          :style="{ transitionDelay: (i % 5) * 60 + 'ms' }"
        >
          <span class="cat__ic ic"><LucideIcon :name="c.icon" :size="26" /></span>
          <span class="cat__name">{{ c.name }}</span>
          <span class="cat__count">{{ c.count }}</span>
        </a>
      </div>
    </div>
  </section>
</template>
